// Module
var code = "<svg aria-hidden=\"true\" role=\"img\"> <use xlink:href=\"assets/icons/defs.svg#icon-pin\"></use> </svg> ";
// Exports
module.exports = code;